// Datalayer forms
import {pushFormDataLayer} from 'js/services/datalayer';

const forms = document.querySelectorAll('form[data-form-data-layer]');

if (forms.length) {
    forms.forEach((form) => {
        form.addEventListener('submit', (event) => {
            event.preventDefault();

            // Disable button
            const submitButton = form.querySelector('button');
            if (submitButton) {
                submitButton.disabled = true;
            }

            // Push data layer
            if ('formDataLayer' in form.dataset) {
                const type = form.dataset.formDataLayer;
                if (type !== '' && type !== 'submit_training_aanmelding') {
                    pushFormDataLayer(form.dataset.formDataLayer);
                }
            }

            form.submit();
        });
    });
}
